import { ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import { CommonModule, DatePipe, NgClass } from '@angular/common';
import { PromotionPeriod } from '../models/promotion-period.model';
import { PromotionData } from '../models/promotion-data.model';
import { SlotTypes } from '../models/slot-types.model';
import { CrudService } from '../services/crud.service';
import { environment } from 'src/environments/environment';
import { DxButtonModule, DxDataGridComponent, DxDataGridModule, DxDropDownButtonModule, DxLoadPanelModule, DxPopupModule, DxTooltipComponent, DxTooltipModule } from 'devextreme-angular';
import { EventsService, Event } from '../services/events.service';
import { WeekRangeValues } from '../week-range-selector/week-range-selector.component';
import { Values } from '../promotion-header/promotion-header.component';
import { on } from "devextreme/events";
import { ConfirmationService } from '../services/confirmation.service';
import CustomStore from 'devextreme/data/custom_store';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotifyService } from '../services/notify.service';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { ConfigService } from '../services/config.service';
import { DateService } from '../services/date.service';
import { DetailViewComponent } from '../detail-view/detail-view.component';
import { WeekRangeSelectorComponent } from '../week-range-selector/week-range-selector.component';
import { CloneSlottingDataComponent } from '../clone-slotting-data/clone-slotting-data.component';
import { ImportPromotionComponent } from '../import-promotion/import-promotion.component';
import { NegotiationComponent } from '../negotiation/negotiation.component';
import { PageHeaderComponent } from 'src/app/shared/page-header/page-header.component';


@Component({
    selector: 'app-data-grid',
    templateUrl: './data-grid.component.html',
    styleUrls: ['./data-grid.component.css'],
    providers: [ DateService, DatePipe ],
    imports: [ CommonModule, NgClass, DxLoadPanelModule, DxDataGridModule, DxButtonModule, DxDropDownButtonModule,
      DxPopupModule, DxTooltipModule,
      DetailViewComponent, WeekRangeSelectorComponent, CloneSlottingDataComponent, ImportPromotionComponent, NegotiationComponent,
      PageHeaderComponent ],
    standalone: true
})

export class DataGridComponent implements OnInit {

  promotionPeriodData: PromotionPeriod[] = [];
  promotionGroupsData: PromotionData[] = [];
  slotTypes: SlotTypes[] = [];
  columns: Array<any> = [];
  tooltipData: any[] = [];
  toolTipText: string;
  tooltipTarget: string = '';
  tooltipHoverTarget: string = '';
  events: Event[] = [];
  startDates: any[] = [];
  calenderWeeks: any[] = [];
  activated: string = '';
  storageKey: string = "slottingState";
  gridBuilt: boolean = false;
  loading: boolean = true;
  suppliers: Supplier[] = [];
  cloneSlottingData: boolean = false;
  importPromotionData: boolean = false;
  showNegotiation: boolean = false;
  promotion_name: string = '';
  promotion_id: number = 0;
  filteredData:any;
  currentFilter: any;
  currentToggleState: ToggleState = ToggleState.ShowAll;
  showFilterRow: boolean | null | undefined = false;
  showVerticalLines: boolean = false;
  hasChanges: boolean = false;
  selectedDayIndex: number = 0;
  dataStartDate: any;
  planningDataStartDate: string = '';
  planningDataNumberOfWeeks: number = 0;
  weekLabels = new Map<number, string>(); // calendar week id -> 'w23', rebuilt with promotionPeriodData
  supplierPortal: boolean = false;
  toggleStateItems = [
    { id: ToggleState.ShowAll, name: 'Show All' },
    { id: ToggleState.ShowWith, name: 'Slotted' },
    { id: ToggleState.ShowWithout, name: 'Unused' }
];


  private apiUrl : string = environment.baseApiUrl;
  @ViewChild('gridContainer', { static: false }) gridContainer: DxDataGridComponent;
  @ViewChild(DxTooltipComponent) tooltip: DxTooltipComponent;
  @ViewChild('toolTipHover', { static: false }) toolTipHover: any;
  selectedItemKeys: any;
  promotionDataMain: any;
  storedPromotionNames: any;

  weekSelector: boolean = false;
    buttonOptions: any = {
        icon: "menu",
        hint:"Select Date Range",
        onClick: () => {
            this.weekSelector = !this.weekSelector;
            this.cdr.detectChanges();
        }
    }
promotionHeaders: Values[] =[];
  constructor(private crudService: CrudService,
              private eventService: EventsService,
              private confirmationService: ConfirmationService,
              private cdr: ChangeDetectorRef,
              private notifyService: NotifyService,
              private configService: ConfigService,
              private dateService: DateService) {


                this.currentFilter = 'auto';

              }

  async ngOnInit(): Promise<void> {
    console.log('init data grid');
    this.selectedItemKeys = [ToggleState.ShowAll];
    const storedData = localStorage.getItem('promotion-headers');
    if (storedData) {
      this.promotionHeaders = JSON.parse(storedData);
    } else {
      const result = await this.crudService.getData(this.apiUrl + 'promotion-headers').toPromise();
      localStorage.setItem('promotion-headers', JSON.stringify(result));

    }
    if(localStorage.getItem('promotion-names') !== null) {
      this.storedPromotionNames = localStorage.getItem('promotion-names');
    } else {
      this.crudService.getData(`${this.apiUrl}promotion-names`).subscribe((result: any) => {
        this.storedPromotionNames = result.data;
        localStorage.setItem('promotion-names', JSON.stringify(result.data));
      });
    }
    this.getConfigString('WeekStartIndex');
    this.getConfigString('SupplierPortal');
    this.dataStartDate = await this.getDataStartDate();
    console.log("selectedDayindex:",this.selectedDayIndex);
    console.log(typeof(this.selectedDayIndex))
    await this.buildGrid();
    this.getCustomStore(this.apiUrl);
  }

  async getDataStartDate() {
    let startDate = this.dateService.twoWeeksAgo(new Date());
    const config = await this.configService.GetConfigByKey('DataStartDate');
    if(config.length !== 0){
      startDate =  config[0].config_string;
    }
    return startDate;
  }

  async getConfigString(config: string) {
    try {
        // Fetching configuration data
        const response = await this.configService.GetConfigByKey(config);

        // Check if the response array is not empty and has the property
        if (response.length > 0 && response[0].config_string) {
          if(config === 'WeekStartIndex') {
            this.selectedDayIndex =  parseInt(response[0].config_string);
          }
          if(config === 'SupplierPortal') {
            this.supplierPortal = Boolean(Number(response[0].config_string));
          }
        } else {
            console.log('No config found or missing config_string');
        }
    } catch (error) {
        console.error('Failed to get config string:', error);
    }
  }
  // Function to toggle the filter row visibility
  toggleFilterRow(): void {
    this.showFilterRow = !this.showFilterRow;
    this.clearFilter();
  }
  showOnlyPromotionPeriodData: boolean = false;

  async applyFilter() {

    // Load data from the CustomStore
   await this.promotionDataMain.load().then((data: PromotionData[]) => {
      this.promotionGroupsData = data; // Set the promotionGroupsData here
    }).catch((error: any) => {
      console.error("Error loading data: ", error);
      this.filteredData = [];
    });
    // Week cells are keyed by calendar week id, prefixed with 'c'
    const validWeekKeys = new Set<string>();

    this.promotionPeriodData.forEach(period => {
      period.week_number.forEach(week => {
        validWeekKeys.add('c' + week.id);
      });
    });
    const weekNumbersArray = Array.from(validWeekKeys) as string[];
    switch(this.currentToggleState) {
      case ToggleState.ShowWith:
        this.filteredData = this.promotionGroupsData.filter(row =>
          weekNumbersArray.some(weekNum => Boolean((row as any)[weekNum])
          )
        );
        break;
      case ToggleState.ShowWithout:
        this.filteredData = this.promotionGroupsData.filter(row =>
          weekNumbersArray.every(weekNum => !(row as any)[weekNum])
        );
        break;
      default: // ShowAll
      this.promotionDataMain.load().then((data: any) => {
      this.filteredData = data;
      });
        break;
    }
  }
  selectedDropDownItem: any = null;
  onDropdownSelectionChanged(e:any) {
    this.selectedDropDownItem = e.item;
    this.currentToggleState = e.item.id;

    this.applyFilter();
}

  clearFilter() {
    this.gridContainer.instance.clearFilter();
  }
  canDeactivate(): Promise<boolean> {
    if (this.gridContainer && this.gridContainer.instance.hasEditData()) {
      return this.confirmationService.confirmUnsavedChangesNavigation();
    } else {
      // if(this.hasChanges) {
      //   console.log('refresh-planning-data');
      //   this.crudService.getData(`${this.apiUrl}refresh-planning-data`).toPromise();
      // }
      return Promise.resolve(true);
    }
  }

  openCloneSelection() {
    this.cloneSlottingData = !this.cloneSlottingData;
  }

  enableVerticalLines() {
    this.showVerticalLines = !this.showVerticalLines;
  }

  loadState()
  {
    console.log('loading state');
    if(localStorage.getItem(this.storageKey) !== null) {
      return JSON.parse(localStorage.getItem(this.storageKey) || '');
    }
  }

  saveState = (state: any) => {
    if(this.gridBuilt) {
      if (state) {
          const numberToRemove = state.columns.length - 4
          state.columns.splice(4, numberToRemove);
      }
      localStorage.setItem(this.storageKey, JSON.stringify(state));
    }
  }

  clearData(): void
  {
    this.promotionPeriodData = [];
    this.promotionGroupsData = [];
    this.slotTypes = [];
    this.columns = [];
  }
  setTimeouts(e:any){
    e.component.option('scrolling.updateTimeout', 1500);
  }
  async buildGrid(weekRangeValues?: WeekRangeValues)
  {
    try {
      await this.buildColumns(weekRangeValues);
    } catch (error) {
      console.error('Error building grid: ', error);
      this.notifyService.tellUser(error);
      this.loading = false;
    }
  }

  private async buildColumns(weekRangeValues?: WeekRangeValues)
  {
    this.clearData();
    const range = weekRangeValues ?? await this.savedWeekRange();
    this.planningDataStartDate = range.startWeek;
    this.planningDataNumberOfWeeks = range.numberOfWeeks;
    const promotionPeriodData: PromotionPeriod[] = await this.crudService.getData(`${this.apiUrl}promotion-periods?start_date=${range.startWeek}&number_of_weeks=${range.numberOfWeeks}`).toPromise();
    this.promotionPeriodData = promotionPeriodData ?? [];
    this.weekLabels = new Map(this.promotionPeriodData.flatMap(p => p.week_number).map(w => [w.id, 'w' + w.number]));
    localStorage.setItem('promotion-periods', JSON.stringify(this.promotionPeriodData));
    const slotTypesData: SlotTypes[] = await this.crudService.getData(`${this.apiUrl}slot-types`).toPromise();
    const slotTypesWithCodeName = slotTypesData.map((slot) => {
      const codeName = slot.code + ' - ' + slot.name;
      return { ...slot, codeName };
    });
    this.slotTypes = slotTypesWithCodeName;
    this.crudService.getData(`${this.apiUrl}calendar-weeks?start_date=${this.dataStartDate}`).subscribe((data:any) => {
      this.calenderWeeks = data;
      this.cdr.detectChanges(); // Update the view
    });
    //this.calenderWeeks = JSON.parse(localStorage.getItem('calender-weeks') || '[]');
    await this.getEvents();
    this.addColumn();
    this.loading = false;
    this.gridBuilt = true;
  }

  getCustomStore(apiUrl: string) {
    this.promotionDataMain = new CustomStore<any>({
      load: async (options) => {
        const take = 5000; // Set the number of items to take per request
        let skip = 0;
        let result: any[] = [];
        let total = 0;

        // only send a window length the API can use; anything else means no end bound
        const window = this.planningDataNumberOfWeeks > 0 ? `&number_of_weeks=${this.planningDataNumberOfWeeks}` : '';

        do {
          const data = await this.crudService
            .getData(`${apiUrl}planning-data?start_date=${this.planningDataStartDate}${window}`, { skip, take })
            .toPromise();
          //console.log('data', data);
          result = result.concat(data?.data ?? []);
          skip += take;
          total = data?.total ?? 0;
        } while (total >= take);
        // The API groups each page on its own, so a promotion group x buying group whose
        // weeks straddle a page boundary arrives as two rows: merge their week keys
        const rows = new Map<string, any>();
        for (const row of result) {
          if (row.promo_group_id == null || row.buying_group_id == null) continue;
          const key = `${row.promo_group_id}_${row.buying_group_id}`;
          rows.set(key, Object.assign(rows.get(key) ?? {}, row));
        }
        //console.log('result', result);
        this.loading = false;
        return Array.from(rows.values()).map((item: any, index: number) => ({ index, ...item }));
      },
    });

    // Load data from the CustomStore
    this.promotionDataMain.load().then((data: any) => {
      this.promotionGroupsData = data; // Set the promotionGroupsData here
      this.filteredData = data; // update filteredData
      let state = this.loadState();
      this.gridContainer.instance.state(state);
      this.gridBuilt = true;
    }).catch((error: any) => {
      console.error("Error loading data: ", error);
      this.filteredData = [];
      this.loading = false;
    });
  }

  async getEvents() {
    this.events = await this.eventService.getEvents(20260101, 20280101); // These dates will need to be supplied when the date range filter is implemented.
  }
  selectedValue: any = null; // initially set to null or any default value

  get dropdownButtonText(): string {
    switch (this.currentToggleState) {
      case ToggleState.ShowWith:
        return 'Slotted';
      case ToggleState.ShowWithout:
        return 'Unused';
      default:
        return 'Show All';
    }
  }
 async reloadGrid(weekRangeValues: WeekRangeValues)
  {
    this.weekSelector = false;
    this.loading = true;
    this.clearData();
    localStorage.setItem('weekRangeValues', JSON.stringify(weekRangeValues));
    console.log("wrv", weekRangeValues);
    await this.buildGrid(weekRangeValues);
    // planning-data is bounded to the window, so a new window needs its own rows;
    // stay in loading until they arrive so Previous/Next can't overlap a reload
    this.loading = true;
    this.getCustomStore(this.apiUrl);
  }

  // The saved window, or 26 weeks from the current week on a first visit
  async savedWeekRange(): Promise<WeekRangeValues> {
    const saved = this.parsedSavedWeekRange();
    if (saved) {
      return saved;
    }
    // the calendar week that started in the last 7 days is the current week
    const today = new Date();
    const sixDaysAgo = this.toYearFirst(new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6));
    const currentWeek: any[] = await this.crudService.getData(`${this.apiUrl}calendar-weeks?start_date=${sixDaysAgo}&limit=1&offset=0`).toPromise();
    const range: WeekRangeValues = {
      startWeek: currentWeek?.[0]?.start_date ?? this.dateService.getCurrentDateYearFirst(),
      numberOfWeeks: 26,
      close: false
    };
    localStorage.setItem('weekRangeValues', JSON.stringify(range));
    return range;
  }

  // A saved range is only usable if it has a YYYY-MM-DD start and a positive length;
  // anything else (older shape, hand-edited, corrupt) is treated as unsaved
  private parsedSavedWeekRange(): WeekRangeValues | null {
    try {
      const saved = JSON.parse(localStorage.getItem('weekRangeValues') ?? 'null');
      if (saved && /^\d{4}-\d{2}-\d{2}$/.test(saved.startWeek) && Number(saved.numberOfWeeks) > 0) {
        return { startWeek: saved.startWeek, numberOfWeeks: Number(saved.numberOfWeeks), close: false };
      }
    } catch {
      // fall through
    }
    localStorage.removeItem('weekRangeValues');
    return null;
  }

  // Move the window back (-1) or forward (1) by its own length, anchored on the window shown
  async shiftWeekRange(direction: number) {
    if (this.loading || !this.planningDataStartDate || !(this.planningDataNumberOfWeeks > 0)) {
      return;
    }
    if (this.gridContainer?.instance.hasEditData()) {
      if (!await this.confirmationService.confirmUnsavedChangesNavigation()) {
        return;
      }
      this.gridContainer.instance.cancelEditData();
    }
    const numberOfWeeks = this.planningDataNumberOfWeeks;
    const [year, month, day] = this.planningDataStartDate.split('-').map(Number);
    const startWeek = this.toYearFirst(new Date(year, month - 1, day + direction * numberOfWeeks * 7));
    await this.reloadGrid({ startWeek, numberOfWeeks, close: false });
  }

  get weekRangeText(): string {
    if (!this.planningDataStartDate || !this.planningDataNumberOfWeeks) {
      return '';
    }
    const [year, month, day] = this.planningDataStartDate.split('-').map(Number);
    const start = new Date(year, month - 1, day);
    const end = new Date(year, month - 1, day + this.planningDataNumberOfWeeks * 7 - 1);
    const format = (d: Date) => d.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
    return `${format(start)} – ${format(end)}`;
  }

  private toYearFirst(date: Date): string {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  }

  async closeCloneSelection() {
    this.cloneSlottingData = false;
    // cloning changes the slots, so refetch the rows as well as the columns
    this.loading = true;
    await this.buildGrid();
    this.getCustomStore(this.apiUrl);
  }

  closeImportSelection() {
    this.importPromotionData = false;
  }

  async onRowInserting(values: any) {
    const userDetails = localStorage.getItem('userDetails');
    const parsedDetails = JSON.parse(userDetails || '{}');
    values.group_id = parsedDetails.data.group_id;
    values.location_id = parsedDetails.data.location_id;
    return await new Promise(async (resolve) => {
      const result: any = await this.crudService.insertData(`${this.apiUrl}planning-data`, values)
      .subscribe((result: any) => {
        resolve(result);
      });
    });
  }

  addColumn() {
    this.startDates = [];
    this.promotionPeriodData.forEach(period => {
        this.columns.push({
            caption: period.promotion_name,
            isBand: true,
            headerTemplate: 'promoTemplate',
            name: period.id,
            dataType: 'string',
            allowReordering: false
        });

        const periodStartDates = period.week_number.map(week => ({
            week_id: week.id,
            start_date: this.getStartDateById(week.id) // start here for issue week dates
        }));

        const periodColumns = period.week_number.map(week => ({
            allowReordering: false,
            caption: week.id,
            minWidth: 80,
            ownerBand: period.promotion_name,
            allowEditing: true,
            dataField: 'c' + week.id, // calendar week id: week numbers repeat every year
            name: this.getStartDateById(week.id),
            dataType: 'string',
            lookup: {
                dataSource: this.slotTypes,
                valueExpr: 'code',
                displayExpr: 'codeName',
                allowClearing: true
            },
            cellTemplate: 'cellTemplate',
            headerTemplate: 'headerTemplate',
            alignment: 'center',
            cssClass: 'week-header',
        }));
        this.startDates = [...this.startDates, ...periodStartDates];
        this.columns = [...this.columns, ...periodColumns];
    });
}
  hasMatchingPromotion(promotion_name: string)
  {
    let hasMatch = false;
    let promotionStatus: string | null = null;
    // Find the promotion name object based on the promotion_name
    if(localStorage.getItem('promotion-names') !== null) {
      const storedPromotionNames: any = localStorage.getItem('promotion-names');
    } else {
      this.crudService.getData(`${this.apiUrl}promotion-names`).subscribe((result: any) => {
        const storedPromotionNames: any = result.data;
        localStorage.setItem('promotion-names', JSON.stringify(result.data));
      });
    }
    const storedPromotionNames = localStorage.getItem('promotion-names');
    const promotion_names: PromotionPeriod[] = storedPromotionNames ? JSON.parse(storedPromotionNames) : [];
    //console.log('promotion_names', promotion_names);
    const foundPromotion = promotion_names.find(promotion => promotion.promotion_name === promotion_name);

    if (foundPromotion) {
      // Check if any promotion header has the same promotion_period_id as the found promotion's id
      const storedData = localStorage.getItem('promotion-headers');
      const promotion_headers: Values[] = storedData ? JSON.parse(storedData) : [];
      hasMatch = promotion_headers.some(header => header.promotion_period_id === foundPromotion.id);
      const matchingHeader = promotion_headers.find(header => header.promotion_period_id === foundPromotion.id);
      if (matchingHeader) {
        hasMatch = true;
        promotionStatus = matchingHeader.status_type;
      }
    }

    return [hasMatch, promotionStatus];
  }
  onCellPrepared(e:any) {
    if(e.column.headerCellTemplate === 'promoTemplate') {
      const [isMatch, status] = this.hasMatchingPromotion(e.column.caption);
      if(e.column.index >= 3 && e.column.isBand && isMatch) {
        if(status === 'open' ){ //Open Status
          e.cellElement.style.setProperty('background-color', '#a9ff6663', 'important');
        }
        if(status === 'restricted' ){ //Review Status
          e.cellElement.style.setProperty('background-color', '#ffea668c', 'important');
        }
        if(status === 'closed' ){ //Confirmed Status
          e.cellElement.style.setProperty('background-color', '#ff585894', 'important');
        }
      }
      let tooltipTimeout: any;
      if (e.column.index >= 3 && e.column.isBand) {
          on(e.cellElement, "mouseover", (arg: any) => {
              if (isMatch) {
                  switch (status) {
                      case 'open': this.toolTipText = "Activated"; break;
                      case 'restricted': this.toolTipText = "In Review"; break;
                      case 'closed': this.toolTipText = "Finalised"; break;
                      default: this.toolTipText = "Right Click To Deactivate"; break;
                  }
              } else {
                if(this.supplierPortal) {
                  this.toolTipText = "Right Click To Negotiate"
                } else {
                  this.toolTipText = "Right Click To Activate";
                }
              }

              // the tooltipHoverTarget tooltip for headers
              if (e.cellElement.id) {
                this.tooltipHoverTarget = '#' + e.cellElement.id;
            }

              let mouseX = arg.clientX;
              let mouseY = arg.clientY;

      // Adjust position of tooltip
      if (this.toolTipHover && this.toolTipHover.instance) {
          // offset so the tooltip doesn't cover the cursor
          this.toolTipHover.instance.option('position', {
            my: 'left top',
            at: 'right top',
            offset: '10 0',
            collision: 'fit',
            boundaryOffset: '10 10',
            of: arg
        });
        tooltipTimeout = setTimeout(() => {
          this.toolTipHover.instance.show(arg.target);
      },1000);
      }
    });
          on(e.cellElement, "mouseout", (arg: any) => {
            clearTimeout(tooltipTimeout);
              this.toolTipHover.instance.hide();
          });
      }
  }
}
  contextMenuItems(e: any)
  {
    if(e.column.index >= 3 && e.column.isBand) {
      const [isMatch] = this.hasMatchingPromotion(e.column.caption);
      if (!isMatch) {
          if (!e.items) {
              e.items = [];
          }
          if(this.supplierPortal) {
            e.items.push({
              text: 'Negotiation',
              onItemClick: () => { this.showNegotiationPopup(e.column) }
            });
          } else {
            e.items.push({
              text: 'Activate Promotion',
              onItemClick: () => { this.contextMenuClick(e.column) }
            });
          }
      } else if(isMatch){
          if (!e.items) {
              e.items = [];
          }
          e.items.push({
              text: 'Already Activated'
          });
      }
    }
  }

   async contextMenuClick(column: any)
  {
    this.importPromotionData = !this.importPromotionData;
    this.promotion_name = column.caption;
    this.promotion_id = column.name;
  }

  async showNegotiationPopup(column: any)
  {
    this.promotion_name = column.caption;
    this.promotion_id = column.name;
    
    // Open the popup first
    this.showNegotiation = true;
    
    // Give Angular a chance to update the DOM and initialize the negotiation component
    setTimeout(() => {
      // The negotiation component will automatically load data via ngOnChanges
      // when the promotion_id input changes
      console.log('Negotiation popup opened for promotion:', this.promotion_name, 'ID:', this.promotion_id);
    }, 100);
  }

  closeNegotiationPopup() {
    this.showNegotiation = false;
    this.promotion_name = '';
    this.promotion_id = 0;
  }

  getStartDateById(idToFind: number): string | undefined {
    const foundObject = this.calenderWeeks.find(week => week.id === idToFind);
    return foundObject ? this.formatDateDayMonth(foundObject.start_date) : undefined;
  }

  // Week-of-year label (w23) for a calendar week id; the column key is the id, so labels can repeat across years
  weekLabel(calendarId: number | string): string {
    return this.weekLabels.get(Number(calendarId)) ?? String(calendarId);
  }

  getSlotTypeColour(code: string): string {
    const slotType = this.slotTypes.find(type => type.code === code);
    return slotType ? slotType.colour : '';
  }

  hasEvent(week_id: number): string {
    let show = 'hidden';
    const hasEvent = this.events.some((event: Event) => {
      return event.week_id === week_id && event.editable == 0;
    });

    if (hasEvent) {
      show = 'visible';
    }
  return show;
  }

  hasCustomEvent(week_id: number): string {
    let show = 'hidden';
    const hasEvent = this.events.some((event: Event) => {
      return event.week_id === week_id && event.editable == 1;
    });

    if (hasEvent) {
      show = 'visible';
    }
  return show;
  }

  refreshDataGrid() {
    this.gridContainer.instance.refresh();
  }

  eventData(e: any) {
    if (e.rowType === "header" && this.events.find(event => event.week_id === e.column.caption)) {
      on(e.cellElement, "mouseover", (arg: any) => {
        this.tooltipData = this.events.filter(event => event.week_id === e.column.caption);
        this.tooltipTarget = '#'+e.cellElement.id;
        this.tooltip.instance.show(arg.target);
      });

      on(e.cellElement, "mouseout", (arg: any) => {
        this.tooltip.instance.hide();
      });
    }
  }

  formatDateDayMonth = (date: string): string =>
  {
    //const selectedDayIndex: number = parseInt(localStorage.getItem('selectedDayIndex') || '0');
    //const selectedDayIndex: any = this.configService.GetConfigByKey('WeekStartIndex');

    const dateParts = date.split('-');
    if (dateParts.length === 3) {
      const year = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1;
      const day = parseInt(dateParts[2], 10);
      const new_date = new Date(year, month, day);
      new_date.setDate(new_date.getDate() + this.selectedDayIndex);
      const formattedDate = new_date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit" });
      return formattedDate;
    }
    return '01-01-2023';
  }

  formatDate(integerDate: number): string {
    const dateStr = integerDate.toString();
    const year = dateStr.substring(0, 4);
    const month = dateStr.substring(4, 6);
    const day = dateStr.substring(6, 8);

    return `${day}-${month}-${year}`;
  }

  styleLookup(e: any)
  {

        if(e.index > 3){
    if (e.parentType == "dataRow" && e.editorName == 'dxSelectBox')
    e.editorOptions.onOpened = function (e: any) {
      e.component._popup.option('width', '150');
    };


    e.editorOptions.onValueChanged = function (ev: any) {
      let selectedItem = ev.component.option("selectedItem");
      if(ev.value) {
        let data: slottingData = {
          weekId: e.caption,
          weekName: e.dataField,
          code: selectedItem.code,
          spanPromotion: selectedItem.span_promotion,
          weekCount: selectedItem.week_count || 1,
        }
          e.setValue(data);
        }
        else {
          e.setValue(e.dataField);
        }
      };
    }

}


  setCellValue = (rowData: any, value: any, currentRowData: any) => {
    if (typeof value === 'string') {
      rowData[value] = null;
      this.autoSave(rowData, currentRowData);
      return;
    }

    // Walk by index across the promotion's actual week list (or all weeks if the
    // slot type spans promotions). Week-number arithmetic broke at w52→w53 in
    // 53-week ISO years (e.g. 2026, 2032) by wrapping straight to w1.
    const startWeekId: number = value.weekId;
    const spans: boolean = value.spanPromotion === 1;

    const walkable: Array<{ id: number; number: number }> = spans
      ? this.promotionPeriodData
          .flatMap(p => p.week_number)
          .slice()
          .sort((a, b) => a.id - b.id)
      : (this.promotionPeriodData.find(p =>
          p.week_number.some(w => w.id === startWeekId)
        )?.week_number ?? []);

    const startIdx = walkable.findIndex(w => w.id === startWeekId);
    if (startIdx >= 0) {
      for (let i = 0; i < value.weekCount; i++) {
        const wk = walkable[startIdx + i];
        if (!wk) break;
        rowData['c' + wk.id] = value.code;
      }
    }
    this.autoSave(rowData, currentRowData);
  }

  async autoSave(rowData: any, currentRowData: any) {
    const updates = [];
    //this.hasChanges = true;
    console.log('rowData', rowData);
    console.log('currentRowData', currentRowData);

    const body = {
      buying_group_id: currentRowData.buying_group_id,
      promo_group_id: currentRowData.promo_group_id,
      group_id: currentRowData.group_id,
      location_id: currentRowData.location_id,
      period_weeks_id: 0,
      slot_type: ''
    };

    const keys = Object.keys(rowData);
    console.log('key', keys);
    for (const key of keys) {
      console.log('key', key);
      const week_id = this.columns.find(c => c.dataField === key);
      if(week_id) {
        const fieldName: string = week_id.dataField;
        body.period_weeks_id = week_id.caption;
        body.slot_type = rowData[fieldName];
      }

      const updatePromise = new Promise(async (resolve, reject) => {
        console.log('updatePromise', body);
        this.crudService.updateData(`${this.apiUrl}planning-data`, 1, body)
            .pipe(
                catchError((error: any) => {
                    this.notifyService.tellUser(error);
                    console.error('Resource not found:', error);
                    return throwError(error);
                    })
            )
            .subscribe(
                result => {
                    resolve(result);
                },
                error => {
                    // Handle other errors here if needed
                    this.notifyService.tellUser(error);
                    console.error('An error occurred:', error);
                    reject(error);
                }
            );
        });

      updates.push(updatePromise);
    }

    // Wait for all updates to complete before executing the final line
    await Promise.all(updates);

    // Now, execute the final line
    //console.log('refresh-planning-data');
    this.gridContainer.instance.saveEditData();
    //await this.crudService.getData(`${this.apiUrl}refresh-planning-data`).toPromise();
    return;
  }

  onExporting(e: any) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Slotting Board');

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
      customizeCell: ({ gridCell, excelCell }) => {
        if(gridCell!.rowType === 'header' && gridCell!.column!.cssClass === 'week-header') {
          excelCell.value = this.weekLabel(gridCell!.column!.caption!) + ' - ' + gridCell!.column!.name;
        }
        if(gridCell!.rowType === 'data' && gridCell!.value !== undefined && gridCell!.column!.cssClass !== 'text_boxs') {
          const hexColour = this.getSlotTypeColour(gridCell!.value);
          excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: hexColour.substring(1) } };
          console.log(this.getSlotTypeColour(gridCell!.value));
        }
      }
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
      });
    });
  }

}

export class slottingData
{
  weekId: number;
  weekName: string;
  id?: number;
  code?: string;
  name?: string;
  codeName?: string;
  colour?: string;
  spanPromotion: boolean;
  weekCount: number;
}

export class Supplier
{
  supplier_code: string;
  supplier_name: string;
}
enum ToggleState {
  ShowAll,
  ShowWith,
  ShowWithout
}
